const SERVER_DOWN = 'Server is down. Try again later.';

function loginFailureMessage(error) {
  const response = error && error.response;
  const data = response && response.data;
  const message = data && data.message;
  const detail = data && data.error;
  const status = response && response.status;

  if (!response || status === 502 || status === 503 || status === 504) {
    return SERVER_DOWN;
  }

  if (message === 'Invalid request timestamp') {
    return 'Login failed: Your device clock may be out of sync with the server. Please check your devices time and date settings.';
  }

  const expiredText = [message, detail]
    .filter((part) => typeof part === 'string')
    .join(' ')
    .toLowerCase();
  if (status === 403 || expiredText.includes('expired')) {
    return 'Your account has expired, please contact support for assistance.';
  }

  if (status === 401) {
    return 'Invalid username or password';
  }

  return detail || message || 'An error occurred during login';
}

module.exports = { loginFailureMessage, SERVER_DOWN };
